// packages/react/src/components/RouteMetrics.tsx
// Route-path CSM metrics for the IVW-2.0 app-shell (ported for IVW-1.0 app.js parity).

import { useEffect } from 'react';
import type { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { publishRoutePath } from './handler/ParentDataHandler';

/**
 * RouteMetrics — renders nothing; owns route-path metric emission.
 *
 * On mount it publishes one SCC_INDUCT route-path count metric for the initial location, then
 * registers a `history.listen` subscription that publishes one metric per subsequent navigation
 * (v1 app.js componentWillMount + history.listen parity). The `history.listen` unlisten function
 * is returned as the effect cleanup so the subscription is removed on unmount (no leak).
 */
const RouteMetrics: FC = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    publishRoutePath(location.pathname);
    const unlisten = history.listen((loc) => publishRoutePath(loc.pathname));
    return unlisten;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return null;
};

export default RouteMetrics;
